import { render } from "./ErrorsMessages.vue?vue&type=template&id=09833fae&scoped=true&lang=html"
import script from "./ErrorsMessages.vue?vue&type=script&lang=js"
export * from "./ErrorsMessages.vue?vue&type=script&lang=js"

import "./ErrorsMessages.vue?vue&type=style&index=0&id=09833fae&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09833fae"]])

export default __exports__